import {NgModule} from '@angular/core';
import {HttpClientModule, HTTP_INTERCEPTORS} from '@angular/common/http';

import {AddTokenInterceptor} from './token-interceptor';

export const httpInterceptorProviders = [
  {provide: HTTP_INTERCEPTORS, useClass: AddTokenInterceptor, multi: true}
];

@NgModule({
  imports: [
    HttpClientModule,
  ],
  exports: [],
  providers: [httpInterceptorProviders]
})
export class TokenInterceptorModule{}
